import React, { useState, useEffect } from "react";
import "react-whatsapp-widget/dist/index.css"; // If using WhatsApp widget styles
import amc6 from "../Assets/images/why us.png";
// import amc6 from "../Assets/amc6.png";
import amc8 from "../Assets/amc8.png";
import { useNavigate } from "react-router-dom";
import Seo from "./Seo";


const Amc = () => {
  // eslint-disable-next-line 
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  const arg = "Stats & Infrastructure";
  // eslint-disable-next-line no-unused-vars
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
   const handleNavItemClick = (path) => {
     navigate(`/${path}`);
     setIsOpen(false); // Close the navbar on item click for smaller screens
   };

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768); // Adjust the threshold as per your requirement
    };

    window.addEventListener("resize", handleResize);

    // Call the handleResize initially to set the initial state
    handleResize();

    // Cleanup event listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   // Handle form submission logic here
  //   console.log("Form Data: ", formData);
  // };

  return (
    <div className="min-h-screen flex-col justify-center items-center text-cs3">
      <Seo
        title="Annual Maintenance Contracts - Infosec Media"
        description="Designed to keep your systems running smoothly year-round, our AMCs provide comprehensive support and regular maintenance to prevent unexpected downtime and costly repairs."
        keywords="Infosec Media, AMC, computer sales,Annual Maintenance Contracts, computer service"
      />
      <h1 className="text-4xl font-bold text-center text-cs3 mt-8 mb-2">
        Why Choose Us?
      </h1>
      <div className="flex items-center justify-center">
        <hr className="h-2 w-2/4 border-cs1 pb-1" />
      </div>

      {/* <div className="flex items-center justify-center  ">
        <div className="m-4 md:w-full flex flex-wrap justify-center">
          {imageData.slice(0, isSmallScreen ? 1 : 6).map((image) => (
            <div
              key={image.id}
              className={`w-${isSmallScreen ? "full" : "1/3"}`}
            >
              <img
                id="amcimage"
                src={image.src}
                alt={image.alt}
                className={` w-full h-72 md:contrast-50 transition ease-in-out duration-500 hover:contrast-100 ${
                  isSmallScreen ? "rounded-3xl" : ""
                }`}
              />
            </div>
          ))}
        </div>
      </div> */}

      {/* Introduction Section */}
      <div className="mb-8 text-center">
        <h2 className="text-2xl font-bold mb-4">
          ({arg})
        </h2>
        
      </div>


      {/* Our AMC Services Section */}
      <div className="mb-8 text-center">
        <h2 className="text-3xl font-semibold mb-2 mt-8 md:mt-12 text-cs7">
           Operational Excellence
        </h2>
        <div className="flex items-center justify-center">
          <hr className="h-2 w-1/4 border-cs7 pb-1" />
        </div>
        <div className="flex flex-col md:flex-row items-center justify-center p-4">
          <img
            src={amc6}
            className="md:w-2/4 w-full h-auto rounded-3xl"
            alt=""
          />
          <div className="md:pl-14 p-4 md:w-3/4 text-left text-lg">
            
                <p className="mb-4 md:text-xl text-base font-bold text-cs1 mt-8">
          Our Infrastructure & Reach Based in a 1100 sq. ft. commercial facility in East Delhi,<br/> we are equipped with 24/7 power backup (UPS/Inverter), high-speed internet connectivity,<br/> and modern Y2K-compliant computing systems to ensure uninterrupted operations.
        </p>
                
          </div>
        </div>
      </div>

      {/* Why Choose Us Section */}
      <div className="mb-6 text-center">
        <h2 className="text-3xl font-semibold mb-2 mt-20 md:mt-12 text-cs7">
           Human Capital
        </h2>
        <div className="flex items-center justify-center">
          <hr className="h-2 w-1/4 border-cs7 pb-1" />
        </div>
        <div className="flex md:flex-row flex-col-reverse items-center justify-center">
          <div className="md:pl-14 p-4 md:w-3/4 text-left text-lg">
            <ul className="list-disc list-inside mb-4 md:text-xl text-base font-semibold text-cs1 mt-8">
              <li className="mb-2">
                <span className="text-cs7 font-bold">Field Force:</span> 40-45 highly energetic and honest field executives.
              </li>
              <li className="mb-2">
                <span className="text-cs7 font-bold">
                  Tele-calling Wing: 
                </span>{" "}
                35 dedicated tele-callers and tracers.
              </li>
              <li className="mb-2">
                <span className="text-cs7 font-bold">
                  Leadership: 
                </span>{" "}
                Directed by Shalini Kaushik & Rakhi Kaushik.
              </li>
              <li className="mb-2">
                <span className="text-cs7 font-bold">
                  Quality Control: 
                </span>{" "}
                Supported by 7 Field Supervisors, three full time <span className="md:ml-7 ml-0">computer operators, two office assistants, five skip tracers, a Legal </span><span className="md:ml-7 ml-0">Advisor, an  Accountant & Chartered Accountant.</span>
              </li>
            </ul>
          </div>
          <img src={amc8} className="md:w-2/4 h-auto rounded-3xl" alt="" />
        </div>
      </div>

      {/* Contact Us Section */}
      <div className=" flex item-center justify-center mb-20 md:mb-20 md:mt-16 ">
        <div className="animated-gradient w-5/6 md:rounded-full rounded-3xl flex-col item-center justify-center md:h-28 h-20">
          <div className="text-white  flex items-center justify-center pt-6 md:text-4xl text-base text-center">
            We Provide the Best Service in Industry
          </div>
          <div className="text-white flex items-center justify-center md:pt-5 h-18">
            <button
              className="md:w-48 pt-3 pb-3 bg-cs1 flex font-semibold items-center justify-between px-4 rounded-full allproduct hover:bg-cs4"
              onClick={() => handleNavItemClick("contact")}
            >
              <div className="flex items-center justify-between w-full">
                <div className="ml-2 flex-nowrap">Contact Us Today</div>
                <div className="">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    style={{ fill: "white" }}
                    viewBox="0 0 32 32"
                    id="arrow"
                  >
                    <path d="M4 15a1 1 0 0 0 1 1h19.586l-4.292 4.292a1 1 0 0 0 1.414 1.414l6-6a.99.99 0 0 0 .292-.702V15c0-.13-.026-.26-.078-.382a.99.99 0 0 0-.216-.324l-6-6a1 1 0 0 0-1.414 1.414L24.586 14H5a1 1 0 0 0-1 1z"></path>
                  </svg>
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Amc;
